import { render, staticRenderFns } from "./GruppoLavorazionePerLottoTabella.vue?vue&type=template&id=0389761d&scoped=true"
import script from "./GruppoLavorazionePerLottoTabella.vue?vue&type=script&lang=ts"
export * from "./GruppoLavorazionePerLottoTabella.vue?vue&type=script&lang=ts"
import style0 from "./GruppoLavorazionePerLottoTabella.vue?vue&type=style&index=0&id=0389761d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0389761d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0389761d')) {
      api.createRecord('0389761d', component.options)
    } else {
      api.reload('0389761d', component.options)
    }
    module.hot.accept("./GruppoLavorazionePerLottoTabella.vue?vue&type=template&id=0389761d&scoped=true", function () {
      api.rerender('0389761d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GruppoLavorazionePerLottoTabella.vue"
export default component.exports